import React from 'react'

import { ISprintAchievedProps } from './interface'
import Badge from 'app/components/Badge'
import './styles.scss'

const bc = 'sprint-achieved'

const SprintAchieved = ({
  sprintResult: { orgGoalAchievedMessage, userGoalAchievedMessage, badge },
}: ISprintAchievedProps) => (
  <div className={`${bc}__wrapper`}>
    {badge && userGoalAchievedMessage && <Badge url={badge} className={`${bc}__badge`} />}
    {orgGoalAchievedMessage && <div className={`${bc}__org-message`}>{orgGoalAchievedMessage}</div>}
    {userGoalAchievedMessage && <div className={`${bc}__user-message`}>{userGoalAchievedMessage}</div>}
  </div>
)

export default SprintAchieved as React.FunctionComponent<ISprintAchievedProps>
